import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, BookOpen, Quote, Image, Award, Settings, LogOut } from "lucide-react";
import { clearToken } from "@/lib/api";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/supporters", label: "Supporters", icon: Users },
  { to: "/admin/research", label: "Research", icon: BookOpen },
  { to: "/admin/endorsements", label: "Endorsements", icon: Quote },
  { to: "/admin/gallery", label: "Gallery", icon: Image },
  { to: "/admin/awards", label: "Awards", icon: Award },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const logout = () => { clearToken(); nav("/admin/login"); };
  return (
    <div className="min-h-screen flex bg-[hsl(var(--bg-muted))]" data-testid="admin-layout">
      <aside className="w-64 bg-white border-r border-[hsl(var(--border-c))] flex flex-col">
        <div className="p-5 border-b border-[hsl(var(--border-c))]">
          <div className="font-display text-xl text-[hsl(var(--primary))]">Campaign CMS</div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-[hsl(var(--fg-muted))]">Dr. Garg · DMC</div>
        </div>
        <nav className="p-3 flex-1 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[hsl(var(--primary))] text-white"
                    : "text-[hsl(var(--fg))] hover:bg-[hsl(var(--bg-muted))]"
                }`
              }>
              <n.icon size={16} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={logout} data-testid="admin-logout-btn"
          className="m-3 px-3 py-2.5 text-sm flex items-center gap-3 text-[hsl(var(--accent))] hover:bg-[hsl(var(--bg-muted))]">
          <LogOut size={16} /> Logout
        </button>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="p-8 max-w-6xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
